"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTaskName = exports.getLimitedTaskName = exports.generateTaskName = exports.getTaskFormattedDate = exports.getWorkTypeName = void 0;
var defaultMaxCharacter = 32;
var getWorkTypeName = function (workType) {
    return workType.name || '';
};
exports.getWorkTypeName = getWorkTypeName;
var getTaskFormattedDate = function () {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var dayOfTheMonth = now.getDate();
    var formattedMonth = "0".concat(month).slice(-2);
    var formattedDayOfTheMonth = "0".concat(dayOfTheMonth).slice(-2);
    return "".concat(year).concat(formattedMonth).concat(formattedDayOfTheMonth);
};
exports.getTaskFormattedDate = getTaskFormattedDate;
var generateTaskName = function (workTypes, maxCharacters) {
    if (maxCharacters === void 0) { maxCharacters = defaultMaxCharacter; }
    var formattedWorkTypes = (0, exports.getWorkTypeName)(workTypes[0]);
    if (workTypes.length > 1) {
        var subWorkType = (0, exports.getWorkTypeName)(workTypes[1]);
        formattedWorkTypes = "".concat(formattedWorkTypes, " ").concat(subWorkType);
    }
    return (0, exports.getLimitedTaskName)(maxCharacters, "".concat((0, exports.getTaskFormattedDate)(), " ").concat(formattedWorkTypes).trimEnd());
};
exports.generateTaskName = generateTaskName;
var getLimitedTaskName = function (maxCharacters, name) {
    if (name && name.length > maxCharacters) {
        return name.slice(0, maxCharacters);
    }
    return name;
};
exports.getLimitedTaskName = getLimitedTaskName;
var getTaskName = function (_a) {
    var oldTaskName = _a.oldTaskName, oldWorkTypes = _a.oldWorkTypes, newWorkTypes = _a.newWorkTypes, _b = _a.maxCharacters, maxCharacters = _b === void 0 ? defaultMaxCharacter : _b;
    if (oldWorkTypes) {
        var generatedOldTaskName = (0, exports.generateTaskName)(oldWorkTypes, maxCharacters);
        if (generatedOldTaskName === oldTaskName) {
            return (0, exports.generateTaskName)(newWorkTypes, maxCharacters);
        }
        return oldTaskName;
    }
    return (0, exports.generateTaskName)(newWorkTypes, maxCharacters);
};
exports.getTaskName = getTaskName;
